module.exports = __webpack_public_path__ + "media/images/pic/anime/mr-popcorn-464c4648793636b80011a3a37ea8534d.svg";